import React from "react";

import CuentasPorCobrarTable from "~/pages/facturas/CuentasPorCobrarTable";

const CuentasPorCobrarPage: React.FC = () => {
  return (
    <div className="w-full max-w-[100vw] px-6 md:max-w-[60vw] md:px-0 lg:max-w-[70vw] xl:max-w-[75vw]">
      <div className="mb-8 flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <h2 className="text-2xl font-bold tracking-tight">
            Cuentas por Cobrar
          </h2>
          <p className="text-muted-foreground">
            Gestión y consulta de cuentas por cobrar de facturas manuales
          </p>
        </div>
      </div>

      <CuentasPorCobrarTable showHeader={false} />
    </div>
  );
};

export default CuentasPorCobrarPage;
